export default __webpack_public_path__ + "static/media/ic_gmx_avax.d5982ce5.svg";